import React from 'react'
import data from '../data/data.json'


const frontend = () => {
    const dataFrontend = data.frontend;
  return (
    <div className="skills__content">
        <h3 className="skills__title">
        Frontend developer
        </h3>
        <div className="skills_box">
            <div className="skills_group">
                <div className="skills__data">
                    <i className='bx bx-badge-check'></i>
                    <div>
                        <h3 className='skills_name'>HTML</h3>
                        <span className='skills__level'>BASIC</span>
                    </div>
                </div>
                {
                    dataFrontend.map(({name,level})=>{
                        return(
                        <div className="skills__data">
                                <i className='bx bx-badge-check'></i>
                            <div>
                                <h3 className='skills_name'>{name}</h3>
                                <span className='skills__level'>{level}</span>
                            </div>
                        </div>
                        )
                    })
                } 
            </div>
        </div>
    </div>
  )
}

export default frontend